const translations = {
  nl: {
    nav: {
      home: 'Home',
      services: 'Diensten',
      municipal: 'Gemeentediensten',
      projects: 'Projecten',
      about: 'Over Ons',
      contact: 'Contact',
      gallery: 'Galerij',
      quote: 'Offerte Aanvragen',
    },
    home: {
      heroTitle: 'Professioneel Onderhoud voor Thuis, Bedrijf & Gemeente',
      heroSubtitle: 'Van kleine klussen thuis tot volledige gemeentelijke contracten – Orange Onderhoudsbedrijf regelt alles vakkundig, betrouwbaar en altijd op tijd.',
      heroCta: 'Offerte Aanvragen',
      heroCta2: 'Onze Diensten',
      servicesTitle: 'Onze Diensten',
      servicesSubtitle: 'Professionele onderhoudsdiensten voor particulieren, bedrijven en gemeenten in Nederland',
      whyTitle: 'Waarom Kiezen voor Orange Onderhoudsbedrijf?',
      projectsTitle: 'Recente Projecten',
      projectsSubtitle: 'Een greep uit ons werk voor particulieren, bedrijven en gemeenten',
      viewAll: 'Alle Projecten Bekijken',
      ctaTitle: 'Klaar om samen te werken?',
      ctaSubtitle: 'Of u nu een kleine klus thuis heeft of een groot gemeentelijk contract zoekt – neem contact op voor een vrijblijvende offerte.',
      ctaButton: 'Neem Contact Op',
      stat1: '10+',
      stat1Label: 'Jaar Ervaring',
      stat2: '500+',
      stat2Label: 'Projecten',
      stat3: '100+',
      stat3Label: 'Tevreden Klanten',
      stat4: '24u',
      stat4Label: 'Reactietijd',
      benefit1Title: 'Betrouwbaar',
      benefit1Desc: 'Altijd op tijd en zoals afgesproken – voor particulieren, bedrijven én gemeenten.',
      benefit2Title: 'Vakkundig',
      benefit2Desc: 'Gecertificeerd vakmanschap voor elk type klus, groot of klein.',
      benefit3Title: 'Duurzaam',
      benefit3Desc: 'Milieuvriendelijke methoden en materialen voor elk project.',
    },
    services: {
      title: 'Onze Diensten',
      subtitle: 'Voor particulieren, bedrijven en gemeenten in heel Nederland',
      quote: 'Offerte Aanvragen',
      description: 'Van een kapotte kraan thuis tot grootschalig gemeentelijk groenonderhoud – wij leveren vakkundige diensten voor elke klant.',
    },
    municipal: {
      title: 'Gemeentediensten',
      subtitle: 'Uw betrouwbare partner voor gemeentelijk onderhoud',
      intro: 'Wij begrijpen de specifieke eisen en procedures van gemeentelijke aanbestedingen. Met onze jarenlange ervaring en expertise zijn wij de ideale partner voor uw gemeente.',
      benefitsTitle: 'Wat wij bieden',
      benefit1Title: 'Flexibele Contracten',
      benefit1Desc: 'Korte en lange termijn contracten op maat voor uw gemeente.',
      benefit2Title: 'Gecertificeerd',
      benefit2Desc: 'Wij voldoen aan alle gemeentelijke kwaliteitsnormen en regelgeving.',
      benefit3Title: 'Lokaal & Snel',
      benefit3Desc: 'Gevestigd in Nederland, altijd snel beschikbaar wanneer nodig.',
      benefit4Title: 'Duurzaam',
      benefit4Desc: 'Milieuvriendelijke werkwijzen en gecertificeerde materialen.',
      processTitle: 'Hoe Werkt Het?',
      step1: 'Aanvraag & Offerte',
      step1Desc: 'U dient een aanvraag in en wij sturen binnen 24 uur een offerte.',
      step2: 'Planning & Afspraken',
      step2Desc: 'Samen plannen we de werkzaamheden op een moment dat past.',
      step3: 'Professionele Uitvoering',
      step3Desc: 'Ons team voert de werkzaamheden vakkundig en efficiënt uit.',
      step4: 'Oplevering & Controle',
      step4Desc: 'Wij leveren op met een kwaliteitscontrole en uw goedkeuring.',
      ctaTitle: 'Interesse in een samenwerking?',
      ctaSubtitle: 'Neem contact op voor meer informatie over onze gemeentediensten.',
      ctaButton: 'Offerte Aanvragen',
    },
    projects: {
      title: 'Onze Projecten',
      subtitle: 'Een overzicht van onze uitgevoerde werkzaamheden',
      noProjects: 'Er zijn nog geen projecten toegevoegd. Kom binnenkort terug!',
      location: 'Locatie',
      year: 'Jaar',
      viewImages: 'Foto\'s Bekijken',
    },
    about: {
      title: 'Over Ons',
      subtitle: 'Leer meer over Orange Onderhoudsbedrijf',
      storyTitle: 'Ons Verhaal',
      storyText: 'Orange Onderhoudsbedrijf is uw betrouwbare partner voor alle soorten onderhoud. Of u nu een particulier bent met een klusje thuis, een bedrijf met onderhoudsvraagstukken of een gemeente met grote contracten – wij staan voor u klaar.',
      missionTitle: 'Onze Missie',
      missionText: 'Wij streven ernaar om voor elke klant de beste service te leveren – van een kleine reparatie thuis tot een volledig gemeentelijk onderhoudscontract. Altijd betrouwbaar, professioneel en duurzaam.',
      valuesTitle: 'Onze Waarden',
      value1: 'Betrouwbaarheid',
      value1Desc: 'U kunt altijd op ons rekenen.',
      value2: 'Kwaliteit',
      value2Desc: 'Alleen het beste is goed genoeg.',
      value3: 'Respect',
      value3Desc: 'Wij behandelen uw eigendommen met zorg.',
      value4: 'Duurzaamheid',
      value4Desc: 'Wij denken aan de toekomst.',
      teamTitle: 'Ons Team',
      teamDesc: 'Ons professionele team staat klaar om uw gemeente te onderhouden.',
    },
    contact: {
      title: 'Contact',
      subtitle: 'Particulier, bedrijf of gemeente? Neem gerust contact met ons op',
      name: 'Naam',
      email: 'E-mailadres',
      subject: 'Onderwerp',
      message: 'Bericht',
      send: 'Verstuur Bericht',
      success: 'Uw bericht is verzonden! Wij nemen zo snel mogelijk contact met u op.',
      error: 'Er is iets misgegaan. Probeer het opnieuw.',
      sending: 'Versturen...',
      infoTitle: 'Contactgegevens',
      emailLabel: 'E-mail',
      whatsappLabel: 'WhatsApp',
      serviceAreaTitle: 'Servicegebied',
      serviceAreaText: 'Wij zijn actief in heel Nederland.',
      namePlaceholder: 'Uw naam',
      emailPlaceholder: 'uw@email.nl',
      phone: 'Telefoonnummer',
      phonePlaceholder: '+31 6 12345678',
      jobType: 'Type Dienst',
      jobTypePlaceholder: '-- Selecteer type dienst --',
      jobTypeHandyman: 'Handyman Oplossingen',
      jobTypeMunicipality: 'Gemeente Services',
      subjectPlaceholder: 'Bijv. Offerte gras maaien',
      messagePlaceholder: 'Beschrijf kort uw klus – bijv. locatie, omvang, gewenste datum...',
    },
    footer: {
      description: 'Vakkundig onderhoud voor particulieren, bedrijven en gemeenten in Nederland.',
      quickLinks: 'Snelle Links',
      services: 'Diensten',
      contact: 'Contact',
      rights: 'Alle rechten voorbehouden.',
      kvk: 'KvK',
      servicesList: ['Gras Maaien', 'Straatvegen', 'Garage Schoonmaken', 'Ramen Wassen', 'Basis Elektra', 'Renovatieprojecten'],
    },
    admin: {
      login: 'Inloggen',
      username: 'Gebruikersnaam',
      password: 'Wachtwoord',
      loginBtn: 'Inloggen',
      loginError: 'Onjuiste gebruikersnaam of wachtwoord.',
      dashboard: 'Dashboard',
      messages: 'Berichten',
      services: 'Diensten',
      projects: 'Projecten',
      content: 'Inhoud',
      logout: 'Uitloggen',
      save: 'Opslaan',
      saved: 'Opgeslagen!',
      delete: 'Verwijderen',
      edit: 'Bewerken',
      add: 'Toevoegen',
      cancel: 'Annuleren',
      unread: 'Ongelezen',
      read: 'Gelezen',
      markRead: 'Markeer als gelezen',
      reply: 'Antwoorden via WhatsApp',
      noMessages: 'Geen berichten.',
      totalMessages: 'Berichten',
      unreadMessages: 'Ongelezen',
      totalServices: 'Diensten',
      totalProjects: 'Projecten',
      addProject: 'Nieuw Project',
      imageUrl: 'Afbeelding URL',
      addImageUrl: 'URL Toevoegen',
      location: 'Locatie',
      year: 'Jaar',
      titleNl: 'Titel (NL)',
      titleEn: 'Titel (EN)',
      titleEs: 'Titel (ES)',
      descNl: 'Beschrijving (NL)',
      descEn: 'Beschrijving (EN)',
      descEs: 'Beschrijving (ES)',
      heroTitle: 'Hero Titel',
      heroSubtitle: 'Hero Subtitel',
      aboutTitle: 'Over Ons Titel',
      aboutText: 'Over Ons Tekst',
      municipalTitle: 'Gemeentediensten Titel',
      municipalText: 'Gemeentediensten Tekst',
      uploadImage: 'Afbeelding Uploaden',
      from: 'Van',
      date: 'Datum',
      status: 'Status',
      actions: 'Acties',
      iconName: 'Icoon Naam',
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      municipal: 'Municipal Services',
      projects: 'Projects',
      about: 'About',
      contact: 'Contact',
      gallery: 'Gallery',
      quote: 'Request Quote',
    },
    home: {
      heroTitle: 'Professional Maintenance for Home, Business & Municipality',
      heroSubtitle: 'From small home repairs to full municipal contracts – Orange Onderhoudsbedrijf handles it all professionally, reliably and always on time.',
      heroCta: 'Request a Quote',
      heroCta2: 'Our Services',
      servicesTitle: 'Our Services',
      servicesSubtitle: 'Professional maintenance services for individuals, businesses and municipalities',
      whyTitle: 'Why Choose Orange Onderhoudsbedrijf?',
      projectsTitle: 'Recent Projects',
      projectsSubtitle: 'A selection of our work for individuals, businesses and municipalities',
      viewAll: 'View All Projects',
      ctaTitle: 'Ready to work together?',
      ctaSubtitle: 'Whether it\'s a small home repair or a large municipal contract – contact us for a free, no-obligation quote.',
      ctaButton: 'Get in Touch',
      stat1: '10+',
      stat1Label: 'Years Experience',
      stat2: '500+',
      stat2Label: 'Projects',
      stat3: '100+',
      stat3Label: 'Happy Clients',
      stat4: '24h',
      stat4Label: 'Response Time',
      benefit1Title: 'Reliable',
      benefit1Desc: 'Always on time and as agreed – for private individuals, businesses and municipalities.',
      benefit2Title: 'Skilled',
      benefit2Desc: 'Certified craftsmanship for every type of job, big or small.',
      benefit3Title: 'Sustainable',
      benefit3Desc: 'Eco-friendly methods and materials for every project.',
    },
    services: {
      title: 'Our Services',
      subtitle: 'For individuals, businesses and municipalities across the Netherlands',
      quote: 'Request Quote',
      description: 'From a leaky tap at home to large-scale municipal maintenance – we provide skilled services for every client.',
    },
    municipal: {
      title: 'Municipal Services',
      subtitle: 'Your reliable partner for municipal maintenance',
      intro: 'We understand the specific requirements and procedures of municipal tenders. With our years of experience and expertise, we are the ideal partner for your municipality.',
      benefitsTitle: 'What we offer',
      benefit1Title: 'Flexible Contracts',
      benefit1Desc: 'Short and long-term contracts tailored to your municipality.',
      benefit2Title: 'Certified',
      benefit2Desc: 'We meet all municipal quality standards and regulations.',
      benefit3Title: 'Local & Fast',
      benefit3Desc: 'Based in the Netherlands, always quickly available when needed.',
      benefit4Title: 'Sustainable',
      benefit4Desc: 'Eco-friendly working methods and certified materials.',
      processTitle: 'How Does It Work?',
      step1: 'Request & Quote',
      step1Desc: 'You submit a request and we send a quote within 24 hours.',
      step2: 'Planning & Agreements',
      step2Desc: 'Together we plan the work at a time that suits you.',
      step3: 'Professional Execution',
      step3Desc: 'Our team performs the work skillfully and efficiently.',
      step4: 'Delivery & Inspection',
      step4Desc: 'We deliver with a quality check and your approval.',
      ctaTitle: 'Interested in a collaboration?',
      ctaSubtitle: 'Contact us for more information about our municipal services.',
      ctaButton: 'Request Quote',
    },
    projects: {
      title: 'Our Projects',
      subtitle: 'An overview of our completed work',
      noProjects: 'No projects added yet. Check back soon!',
      location: 'Location',
      year: 'Year',
      viewImages: 'View Photos',
    },
    about: {
      title: 'About Us',
      subtitle: 'Learn more about Orange Onderhoudsbedrijf',
      storyTitle: 'Our Story',
      storyText: 'Orange Onderhoudsbedrijf is your reliable partner for all types of maintenance. Whether you\'re a private individual with a repair at home, a business with maintenance needs, or a municipality with large contracts – we are here for you.',
      missionTitle: 'Our Mission',
      missionText: 'We strive to deliver the best service to every client – from a small home repair to a full municipal maintenance contract. Always reliable, professional and sustainable.',
      valuesTitle: 'Our Values',
      value1: 'Reliability',
      value1Desc: 'You can always count on us.',
      value2: 'Quality',
      value2Desc: 'Only the best is good enough.',
      value3: 'Respect',
      value3Desc: 'We treat your property with care.',
      value4: 'Sustainability',
      value4Desc: 'We think about the future.',
      teamTitle: 'Our Team',
      teamDesc: 'Our professional team is ready to maintain your municipality.',
    },
    contact: {
      title: 'Contact',
      subtitle: 'Private individual, business or municipality? Feel free to get in touch',
      name: 'Name',
      email: 'Email Address',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      success: 'Your message has been sent! We will contact you as soon as possible.',
      error: 'Something went wrong. Please try again.',
      sending: 'Sending...',
      infoTitle: 'Contact Information',
      emailLabel: 'Email',
      whatsappLabel: 'WhatsApp',
      serviceAreaTitle: 'Service Area',
      serviceAreaText: 'We operate throughout the Netherlands.',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'your@email.com',
      phone: 'Phone Number',
      phonePlaceholder: '+31 6 12345678',
      jobType: 'Type of Service',
      jobTypePlaceholder: '-- Select type of service --',
      jobTypeHandyman: 'Handyman Solutions',
      jobTypeMunicipality: 'Gemeente Services',
      subjectPlaceholder: 'e.g. Quote for grass cutting',
      messagePlaceholder: 'Briefly describe your job – e.g. location, size, preferred date...',
    },
    footer: {
      description: 'Skilled maintenance for individuals, businesses and municipalities across the Netherlands.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contact: 'Contact',
      rights: 'All rights reserved.',
      kvk: 'Chamber of Commerce',
      servicesList: ['Grass Cutting', 'Street Cleaning', 'Garage Cleaning', 'Window Cleaning', 'Basic Electrical', 'Renovation Projects'],
    },
    admin: {
      login: 'Login',
      username: 'Username',
      password: 'Password',
      loginBtn: 'Login',
      loginError: 'Invalid username or password.',
      dashboard: 'Dashboard',
      messages: 'Messages',
      services: 'Services',
      projects: 'Projects',
      content: 'Content',
      logout: 'Logout',
      save: 'Save',
      saved: 'Saved!',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      cancel: 'Cancel',
      unread: 'Unread',
      read: 'Read',
      markRead: 'Mark as read',
      reply: 'Reply via WhatsApp',
      noMessages: 'No messages.',
      totalMessages: 'Messages',
      unreadMessages: 'Unread',
      totalServices: 'Services',
      totalProjects: 'Projects',
      addProject: 'New Project',
      imageUrl: 'Image URL',
      addImageUrl: 'Add URL',
      location: 'Location',
      year: 'Year',
      titleNl: 'Title (NL)',
      titleEn: 'Title (EN)',
      titleEs: 'Title (ES)',
      descNl: 'Description (NL)',
      descEn: 'Description (EN)',
      descEs: 'Description (ES)',
      heroTitle: 'Hero Title',
      heroSubtitle: 'Hero Subtitle',
      aboutTitle: 'About Title',
      aboutText: 'About Text',
      municipalTitle: 'Municipal Title',
      municipalText: 'Municipal Text',
      uploadImage: 'Upload Image',
      from: 'From',
      date: 'Date',
      status: 'Status',
      actions: 'Actions',
      iconName: 'Icon Name',
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      municipal: 'Servicios Municipales',
      projects: 'Proyectos',
      about: 'Nosotros',
      contact: 'Contacto',
      gallery: 'Galería',
      quote: 'Solicitar Presupuesto',
    },
    home: {
      heroTitle: 'Mantenimiento Profesional para Hogar, Empresa y Municipio',
      heroSubtitle: 'Desde pequeñas reparaciones en el hogar hasta contratos municipales completos – Orange Onderhoudsbedrijf lo gestiona todo con profesionalismo y puntualidad.',
      heroCta: 'Solicitar Presupuesto',
      heroCta2: 'Nuestros Servicios',
      servicesTitle: 'Nuestros Servicios',
      servicesSubtitle: 'Servicios de mantenimiento para particulares, empresas y municipios',
      whyTitle: '¿Por qué elegir Orange Onderhoudsbedrijf?',
      projectsTitle: 'Proyectos Recientes',
      projectsSubtitle: 'Una selección de nuestro trabajo para particulares, empresas y municipios',
      viewAll: 'Ver Todos los Proyectos',
      ctaTitle: '¿Listo para trabajar juntos?',
      ctaSubtitle: 'Ya sea una pequeña reparación en casa o un gran contrato municipal – contáctenos para un presupuesto gratuito sin compromiso.',
      ctaButton: 'Contáctenos',
      stat1: '10+',
      stat1Label: 'Años de Experiencia',
      stat2: '500+',
      stat2Label: 'Proyectos',
      stat3: '100+',
      stat3Label: 'Clientes Satisfechos',
      stat4: '24h',
      stat4Label: 'Tiempo de Respuesta',
      benefit1Title: 'Confiable',
      benefit1Desc: 'Siempre a tiempo y como acordado – para particulares, empresas y municipios.',
      benefit2Title: 'Cualificado',
      benefit2Desc: 'Mano de obra certificada para todo tipo de trabajo, grande o pequeño.',
      benefit3Title: 'Sostenible',
      benefit3Desc: 'Métodos y materiales respetuosos con el medio ambiente.',
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Para particulares, empresas y municipios en los Países Bajos',
      quote: 'Solicitar Presupuesto',
      description: 'Desde un grifo que gotea en casa hasta mantenimiento municipal a gran escala – prestamos servicios cualificados para cada cliente.',
    },
    municipal: {
      title: 'Servicios Municipales',
      subtitle: 'Su socio de confianza para el mantenimiento municipal',
      intro: 'Entendemos los requisitos y procedimientos específicos de las licitaciones municipales. Con nuestra experiencia y expertise, somos el socio ideal para su municipio.',
      benefitsTitle: 'Lo que ofrecemos',
      benefit1Title: 'Contratos Flexibles',
      benefit1Desc: 'Contratos a corto y largo plazo adaptados a su municipio.',
      benefit2Title: 'Certificado',
      benefit2Desc: 'Cumplimos todos los estándares y regulaciones municipales.',
      benefit3Title: 'Local y Rápido',
      benefit3Desc: 'Con sede en los Países Bajos, siempre disponibles rápidamente.',
      benefit4Title: 'Sostenible',
      benefit4Desc: 'Métodos de trabajo ecológicos y materiales certificados.',
      processTitle: '¿Cómo Funciona?',
      step1: 'Solicitud y Presupuesto',
      step1Desc: 'Envíe una solicitud y le enviamos un presupuesto en 24 horas.',
      step2: 'Planificación y Acuerdos',
      step2Desc: 'Juntos planificamos el trabajo en el momento que le convenga.',
      step3: 'Ejecución Profesional',
      step3Desc: 'Nuestro equipo realiza el trabajo con habilidad y eficiencia.',
      step4: 'Entrega e Inspección',
      step4Desc: 'Hacemos entrega con un control de calidad y su aprobación.',
      ctaTitle: '¿Interesado en una colaboración?',
      ctaSubtitle: 'Contáctenos para más información sobre nuestros servicios municipales.',
      ctaButton: 'Solicitar Presupuesto',
    },
    projects: {
      title: 'Nuestros Proyectos',
      subtitle: 'Un resumen de nuestro trabajo realizado',
      noProjects: 'No hay proyectos añadidos. ¡Vuelva pronto!',
      location: 'Ubicación',
      year: 'Año',
      viewImages: 'Ver Fotos',
    },
    about: {
      title: 'Nosotros',
      subtitle: 'Conozca más sobre Orange Onderhoudsbedrijf',
      storyTitle: 'Nuestra Historia',
      storyText: 'Orange Onderhoudsbedrijf es su socio de confianza para todo tipo de mantenimiento. Ya sea un particular con una reparación en casa, una empresa con necesidades de mantenimiento o un municipio con grandes contratos – estamos aquí para usted.',
      missionTitle: 'Nuestra Misión',
      missionText: 'Nos esforzamos por ofrecer el mejor servicio a cada cliente – desde una pequeña reparación en el hogar hasta un contrato de mantenimiento municipal completo. Siempre confiables, profesionales y sostenibles.',
      valuesTitle: 'Nuestros Valores',
      value1: 'Fiabilidad',
      value1Desc: 'Siempre puede contar con nosotros.',
      value2: 'Calidad',
      value2Desc: 'Solo lo mejor es suficientemente bueno.',
      value3: 'Respeto',
      value3Desc: 'Tratamos su propiedad con cuidado.',
      value4: 'Sostenibilidad',
      value4Desc: 'Pensamos en el futuro.',
      teamTitle: 'Nuestro Equipo',
      teamDesc: 'Nuestro equipo profesional está listo para mantener su municipio.',
    },
    contact: {
      title: 'Contacto',
      subtitle: '¿Particular, empresa o municipio? No dude en ponerse en contacto con nosotros',
      name: 'Nombre',
      email: 'Correo Electrónico',
      subject: 'Asunto',
      message: 'Mensaje',
      send: 'Enviar Mensaje',
      success: '¡Su mensaje ha sido enviado! Nos pondremos en contacto lo antes posible.',
      error: 'Algo salió mal. Por favor, inténtelo de nuevo.',
      sending: 'Enviando...',
      infoTitle: 'Información de Contacto',
      emailLabel: 'Correo Electrónico',
      whatsappLabel: 'WhatsApp',
      serviceAreaTitle: 'Área de Servicio',
      serviceAreaText: 'Operamos en toda Holanda.',
      namePlaceholder: 'Su nombre',
      emailPlaceholder: 'su@correo.com',
      phone: 'Número de Teléfono',
      phonePlaceholder: '+31 6 12345678',
      jobType: 'Tipo de Servicio',
      jobTypePlaceholder: '-- Seleccione tipo de servicio --',
      jobTypeHandyman: 'Soluciones de Mantenimiento',
      jobTypeMunicipality: 'Servicios Municipales',
      subjectPlaceholder: 'Ej. Presupuesto para corte de césped',
      messagePlaceholder: 'Describa brevemente su trabajo – ej. ubicación, tamaño, fecha preferida...',
    },
    footer: {
      description: 'Mantenimiento cualificado para particulares, empresas y municipios en los Países Bajos.',
      quickLinks: 'Enlaces Rápidos',
      services: 'Servicios',
      contact: 'Contacto',
      rights: 'Todos los derechos reservados.',
      kvk: 'Cámara de Comercio',
      servicesList: ['Corte de Césped', 'Limpieza de Calles', 'Limpieza de Garajes', 'Limpieza de Ventanas', 'Electricidad Básica', 'Proyectos de Renovación'],
    },
    admin: {
      login: 'Iniciar Sesión',
      username: 'Usuario',
      password: 'Contraseña',
      loginBtn: 'Iniciar Sesión',
      loginError: 'Usuario o contraseña incorrectos.',
      dashboard: 'Panel de Control',
      messages: 'Mensajes',
      services: 'Servicios',
      projects: 'Proyectos',
      content: 'Contenido',
      logout: 'Cerrar Sesión',
      save: 'Guardar',
      saved: '¡Guardado!',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Añadir',
      cancel: 'Cancelar',
      unread: 'No leído',
      read: 'Leído',
      markRead: 'Marcar como leído',
      reply: 'Responder por WhatsApp',
      noMessages: 'No hay mensajes.',
      totalMessages: 'Mensajes',
      unreadMessages: 'No leídos',
      totalServices: 'Servicios',
      totalProjects: 'Proyectos',
      addProject: 'Nuevo Proyecto',
      imageUrl: 'URL de Imagen',
      addImageUrl: 'Añadir URL',
      location: 'Ubicación',
      year: 'Año',
      titleNl: 'Título (NL)',
      titleEn: 'Título (EN)',
      titleEs: 'Título (ES)',
      descNl: 'Descripción (NL)',
      descEn: 'Descripción (EN)',
      descEs: 'Descripción (ES)',
      heroTitle: 'Título Hero',
      heroSubtitle: 'Subtítulo Hero',
      aboutTitle: 'Título Nosotros',
      aboutText: 'Texto Nosotros',
      municipalTitle: 'Título Municipal',
      municipalText: 'Texto Municipal',
      uploadImage: 'Subir Imagen',
      from: 'De',
      date: 'Fecha',
      status: 'Estado',
      actions: 'Acciones',
      iconName: 'Nombre Icono',
    }
  }
};

export default translations;
